import React, { useState } from "react";
import { WrapPerformanceReport, GenerateFreeText } from "@components/teachV2/performanceReport";
import styled from "styled-components";
import { useHistory, useLocation } from "react-router-dom";

const WrapCommon = styled.div`
  display: flex;
  flex-direction: column;
  gap: 40px;
  width: 100%;
  padding: 80px 0;
  .list-choice {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 20px;
  }
`

const WrapHeader = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 8px;
  text-align: center;
  img {
    margin-bottom: 16px;
    width: 250px;
  }
  h1 {
    color: #101828;
    font-size: 32px;
    font-weight: 600;
    line-height: 42px;
  }
  div, p {
    color: #344054;
    font-size: 16px;
    font-weight: 400;
    line-height: 24px;
    letter-spacing: 0.5px;
  }
`

const WrapItemOption = styled.div`
  padding: 20px;
  background: #fff;
  border-radius: 8px;
  border: 1px solid #D0D5DD;
  min-width: 310px;
  max-width: 310px;
  cursor: pointer;  
  width: auto;
  display: flex;
  flex-direction: column;
  gap: 4px;
  height: 132px;
  &:hover {
    border: 1px solid #0089C2;
  }
  .item-header {
    color: #101828;
    font-size: 16px;
    font-weight: 600;
    line-height: 150%; /* 24px */
    text-align: center;
  }
  .text-sub {
    color: #344054;
    font-size: 14px;
    font-weight: 400;
    line-height: 20px; /* 142.857% */
    text-align: center;
  }
`

const listGenerate = [
  {
    "title": "Generate Multiple Choice Question",
    "value": 1,
    "description": "AI-generated question content based on your input.",
    "type": "mcq",
  },
  {
    "title": "Create Free-text Question (Manually)",
    "value": 2,
    "description": "Manually enter the question content.",
    "type": "free-text",
  }
]

const CreateMcqMultiple = () => {
  const history = useHistory();
  const location = useLocation();
  const { pathname } = location;
  const [dataChoice, setDataChoice] = useState(pathname === "/teach/mcq" ? listGenerate[0] : pathname === "/teach/free-text" ? listGenerate[1] : null)

  const handleChoose = (data) => {
    setDataChoice(data)
    if(data?.value === 1) {
      history.push("/teach/mcq")
    } else {
      history.push("/teach/free-text")
    }
  }
  return (
    <div>
      {dataChoice ? (
        dataChoice?.type === 'mcq' ? (
          <WrapPerformanceReport dataChoice={dataChoice} setDataChoice={setDataChoice}/>
        ) : (
          <GenerateFreeText />
        )
      ) : (
        <WrapCommon>
          <WrapHeader>
            <h1>Create a New Question</h1>
            <p>Select a question type and creation method that best fit your needs.</p>
          </WrapHeader>
          <div className="list-choice">
            {listGenerate?.map((data, index) => (
              <WrapItemOption 
                onClick={() => handleChoose(data)}
              >
                <h1 className="item-header">{data?.title}</h1>
                <p className="text-sub">{data?.description}</p>
              </WrapItemOption>
            ))}
          </div>
        </WrapCommon>
      )}
    </div>
  );
};

export default CreateMcqMultiple;
